module.exports = __webpack_public_path__ + "static/media/11.5c566fc8.jpg";